/** Parse keypad pesos without floating-point money arithmetic. */
export function cashAmountCentavos(value: string): number {
  if (!/^\d*(?:\.\d{0,2})?$/.test(value)) return 0;
  const [pesos = '', cents = ''] = value.split('.');
  const amount = Number(pesos || '0') * 100 + Number(cents.padEnd(2, '0'));
  return Number.isSafeInteger(amount) ? amount : 0;
}
